import { Injectable } from '@angular/core';
import { RestAPIService } from '../rest-api.service';
@Injectable({
  providedIn: 'root'
})
export class BluealtairtravelUrlService {
  private readonly travelBaseApi = '/api/blue-altair-travels';
  private readonly user = '/user';
  private readonly userId_param = 'userId'
  constructor(private restApi:RestAPIService) { }
  getBaseUrl(){
    return this.travelBaseApi;
  }
  getUserUrl(userId) {
    return this.travelBaseApi + this.user
      + '?' + this.userId_param + '=' + userId
  }
  getByFieldUrl(field){
    return this.travelBaseApi+ this.getByField(field)
  }
  private getByField(field){
    return '/'+field;
  }
}
